export default Object.freeze({
  CREATE_USER: 20_010,
  EDIT_USER: 20_011,
  ENABLE_USER: 20_013,
  DISABLE_USER: 20_014,
  LOGIN: 20_015,
  SET_PASSWORD: 20_017,
  RESET_PASSWORD: 20_018,
  LOGIN_FAILED: 20_019,
  CREATE_APIKEY: 20_021,
  DELETE_APIKEY: 20_022
});
